export const mainContentWidth = '80%';
export const mainContentPaddingLeft = '10%';
export const BIGGEST_SLIDER_CIRCLE_RADIUS = 10;

